module.exports = __webpack_public_path__ + "media/images/courses/powered_by_google-afb0ae4b348df81456d28d5c7145da67.png";